<template>
  <div class="position-relative" v-window-click="windowClicked" v-scroll="rerender" v-resize="rerender">
    <div>
      <slot />
    </div>
    <div class="drop-down" :style="dropDownStyle" @click.stop.prevent v-if="value">
      <slot name="drop-down" />
    </div>
  </div>
</template>

<script>
import { Debouncer } from '../../../libraries/common';

export default {
  noExport: true,
  props: ['value'],
  data() {
    return {
      openDebouncer: new Debouncer(100),
      width: null,
      top: null,
    };
  },
  computed: {
    dropDownStyle() {
      return {
        width: `${this.width}px`,
        maxWidth: `${this.width}px`,
        top: `${this.top}px`
      }
    },
  },
  methods: {
    calculatePosition() {
      if (this._isMounted && this.value) {
        var bndBox = this.$el.getBoundingClientRect();
        if (bndBox.width !== this.width)
          this.width = bndBox.width;
        if (bndBox.bottom !== this.top)
          this.top = bndBox.bottom;
      }
    },
    rerender: function rerender(reset) {
      if (this.value) {
        if (reset) rerender.count = 3;
        requestAnimationFrame(() => {
          rerender.count--;
          this.calculatePosition();
          if (rerender.count > 0) this.rerender();
        });
      }
    },
    openOptions() {
      this.openDebouncer.clear()
        .push(() => this.$emit('input', true));
    },
    hideOptions() {
      this.$emit('input', false);
    },
    windowClicked() {
      this.hideOptions();
    },
  },
  updated() {
    this.calculatePosition();
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisDropDownFixed'] = this;
  },
}
</script>

<style lang="scss" scoped>
.drop-down {
  position: fixed;
  background-color: white;
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
  // padding: 20px 16px 4px;
  box-shadow: 0 1px 4px 1px rgba(6, 10, 36, 0.1), 0 5px 10px 0 rgba(6, 10, 36, 0.08);
  z-index: 1;
}
</style>